/**
 * Shared email/phone field helpers for the signup surfaces
 * (`/get-started`, `/signup`). Validation intent mirrors the server's
 * checks in `server/src/routes/auth.ts`.
 */

/** Pragmatic "is this a real email" check (matches the server's intent). */
export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

/** Pragmatic "is this a real phone" check — at least 10 digits (matches the server). */
export function isValidPhone(value: string): boolean {
  return (value.match(/\d/g)?.length ?? 0) >= 10
}

/** Format as a US phone number while typing: "(503) 555-0142". */
export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  if (digits.length === 0) {
    return ''
  }
  if (digits.length < 4) {
    return `(${digits}`
  }
  if (digits.length < 7) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

/** `/signin`, carrying the email along so the sign-in form is prefilled. */
export function signinHrefForEmail(email: string): string {
  const trimmed = email.trim()
  return isValidEmail(trimmed) ? `/signin?email=${encodeURIComponent(trimmed)}` : '/signin'
}
